import styled, { useTheme } from 'styled-components';

// style.ts
import { Button, Flex, Typography } from '../../../designComponents';
import { ContainerStyled } from './style';

export const HowItWorksStyled = styled.section`
  padding: 80px 0;
`;

export const StepCardStyled = styled.div`
  flex: 1 1 250px;
  max-width: 300px;
  text-align: center;

  .step-img {
    width: 80px;
    height: 80px;
    object-fit: contain;
    margin-bottom: 15px;
  }
`;

const ProfessionalSlogan = () => {
  const theme = useTheme();

  const steps = [
    {
      title: 'Upload your plans',
      description: 'PDF, DWG, image, hand-drawn sketch — all accepted',
    },
    {
      title: 'We redraw & standardise',
      description: 'Clean, accurate, regulation-ready diagrams',
    },
    {
      title: 'Download or let us print',
      description: 'Download PDF instantly or choose printing + delivery',
    },
  ];

  return (
    <HowItWorksStyled>
      <ContainerStyled>
        <Typography
          variant="heading"
          strong
          style={{
            marginBottom: '40px',
            textAlign: 'center',
            color: theme.colors.primary,
          }}
        >
          How It Works
        </Typography>

        <Flex gap="30px" justifyContent="space-between" wrap="wrap">
          {steps.map((step, index) => (
            <StepCardStyled key={index}>
              {/* <img src={step.img} alt={step.title} className="step-img" /> */}
              <Typography
                variant="title"
                strong
                style={{ margin: '15px 0 10px' }}
              >
                {`Step ${index + 1} – ${step.title}`}
              </Typography>
              <Typography>{step.description}</Typography>
            </StepCardStyled>
          ))}
        </Flex>

        <Flex justifyContent="center" style={{ marginTop: '50px' }}>
          <Button style={{ borderRadius: '28px', padding: '12px 24px' }}>
            Upload Plans & Get Started
          </Button>
        </Flex>
      </ContainerStyled>
    </HowItWorksStyled>
  );
};

export default ProfessionalSlogan;
